
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConverterDcacOff as ObiConverterDcacOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-converter-dcac-off.js';
 
 
 

 
 export const ObiConverterDcacOff = createComponent({
   react: React,
   tagName: 'obi-converter-dcac-off',
   elementClass: ObiConverterDcacOffElement,
   events: {
     
   }
  });
 
 